import { useQuery } from "@tanstack/react-query";
import { configViewApi } from "@/lib/api";

export function useConfigView(module: string) {
  return useQuery({
    queryKey: ["config-view", module],
    queryFn: () => configViewApi.get(module),
    staleTime: 10_000,
    enabled: !!module,
  });
}